require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./responsive-web-design-css-flexbox-use-the-align-items-property-in-the-tweet-embed.json") })
        }
      }, "path---responsive-web-design-css-flexbox-use-the-align-items-property-in-the-tweet-embed");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---responsive-web-design-css-flexbox-use-the-align-items-property-in-the-tweet-embed!./.cache/json/responsive-web-design-css-flexbox-use-the-align-items-property-in-the-tweet-embed.json
// module id = 2664
// module chunks = 231608221292675